<form [formGroup]="saveQueryForm" novalidate (ngSubmit)="save()">
  <section class="sh-dialog__content">
    @if (errorNotification$ | async; as notification) {
      <sh-notification
        [message]="notification?.message"
        [icon]="notification?.icon"
        [type]="notification?.type"
      ></sh-notification>
    }

    <sh-form-text-input
      id="new-save-query-name"
      [label]="'components.saved-queries.new-saved-query-dialog.controls.name.label' | translate"
      [control]="nameControl"
      [errorMsg]="nameControl.getError('message') || 'form.error.required-field' | translate"
      [errorResponse]="ErrorResponse.TOUCHED"
      >
    </sh-form-text-input>
    <sh-form-multi-select
      id="new-save-query-groups"
      [label]="'components.saved-queries.new-saved-query-dialog.controls.groups.label' | translate"
      [options]="groups$ | async"
      [control]="groupsControl"
      [multiple]="true"
      [multipleSelectedMsg]="'components.saved-queries.new-saved-query-dialog.controls.groups.multiple-selected' | translate"
      [listCappedMsg]="'components.saved-queries.new-saved-query-dialog.controls.groups.capped' | translate"
      [inOverflownContainer]="true"
    ></sh-form-multi-select>
  </section>
  <footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
      <button class="sh-button sh-action-group__item" type="submit" (click)="save()" [disabled]="!(canSaveSearch$ | async)">
        {{ "components.saved-queries.new-saved-query-dialog.actions.save" | translate }} {{ (saveLoading$ | async) ? "..." : "" }}
      </button>
      <button class="sh-button--secondary sh-action-group__item" (click)="close()">
        {{ "components.saved-queries.new-saved-query-dialog.actions.cancel" | translate }}
      </button>
    </div>
  </footer>
</form>
